import styled from '@emotion/styled';
import { ButtonPrimary } from './layout/StyledComponents';
import { Link } from 'gatsby';

export const PatientButtonsStyled = styled.section`
    margin-top: 32px;
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        a {
            :hover {
                text-decoration: none;
            }
        }
        p {
            font-weight: bold;
            font-size: 20px;
        }
        a {
            align-items: start;
            margin-top: -32px;
            margin-bottom: 16px;
            height: 100px;
            padding: 0;
        }
    }
    @media ${({ theme }) => theme.device.tablet} {
        display: flex;
        justify-content: center;
        gap: 32px;
    }
    @media ${({ theme }) => theme.device.laptop} {
        gap: 64px;
    }
    @media ${({ theme }) => theme.device.laptopL} {
        gap: 84px;
    }
`;

export const PatientButtons: React.FC = () => {
    return (
        <PatientButtonsStyled>
            <div>
                <p>Santa Clarita</p>
                <a
                    href="https://form.flexdental.co/eae5e564b93323480379a06d04dd4fccfccac770c3587e7eb8c36f32f65ca3ac/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary fill color="blue">
                        <span>{`Patient info form for Santa Clarita location`}</span>
                    </ButtonPrimary>
                </a>
            </div>
            <div>
                <p>Porter Ranch</p>
                <a
                    href="https://app.meetaxle.com/EmbedPreviewForm.aspx?FormId=10104A1A311,319,312,2,314,225,226,318AAIsNewPatient"
                    target="__blank"
                >
                    <ButtonPrimary fill color="blue">
                        <span>{`Patient info form for Porter Ranch location`}</span>
                    </ButtonPrimary>
                </a>
            </div>
        </PatientButtonsStyled>
    );
};
